export const intersect = (arr1: any[], arr2: string[], key: string): any[] => {
    let result: any[] = [];
    arr1.forEach(f => {
        if (f[key] && arr2.includes(f[key])) {
            result.push(f);
        }
    })
    return result;
}

export const copyArray = (arr: any[]): any[] => {
    return JSON.parse(JSON.stringify(arr));
}

export function copyArrayRecursive(aObject: any): any {
    // Prevent undefined objects
    // if (!aObject) return aObject;
    let bObject: any = Array.isArray(aObject) ? [] : {};
    let value;
    for (const key in aObject) {
        // Prevent self-references to parent object
        // if (Object.is(aObject[key], aObject)) continue;
        value = aObject[key];
        bObject[key] = (typeof value === "object") ? copyArrayRecursive(value) : value;
    }
    return bObject;

}